<template>
    <div class="modal">
        <img class="error_icon" src="@/assets/img/error.svg" alt="">
        <div class="error_text">{{ $store.getters.errorMessage }}</div>
        <div class="buttons">
            <div @click="$store.commit('changeShowModal', 'Error')" class="cancel">
                <img src="@/assets/img/left_arrow.svg" alt="">
                <div class="text">Назад</div>
            </div>
        </div>

        <div @click="$store.commit('changeShowModal', 'Error')" class="close">
            <img src="@/assets/img/close.svg" alt="">
        </div>
    </div>
</template>


<style lang="scss" scoped>
.modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    .error_text {
        max-width: 300px;
    }
    .error_icon {
        margin-bottom: 44px;
    }
    .buttons {
        .cancel {
            .text {
                font-weight: 700;
            }
        }
    }
}
</style>